module.exports = __webpack_public_path__ + "static/media/d7e2cc8550cba88f118186e51c38d72c.d7e2cc85.webp";